import React, {PropTypes} from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import postAShipmentActions from '../post_a_shipment_actions';
import UploadPhotoComponent from '../../image_upload/image_upload'
import './upload_shipment_photo.less';
import {Link, browserHistory} from 'react-router';
import LoggedinFooter from '../../footer/loggedin_footer';
import shipmentActions from '../../shipment/shipment_actions';
import {toTitleCase,join,localTimestampToGMT,GMTTimeStampToLocal} from '../../util/common';
import moment from 'moment';
import CONSTANTS from '../../common_constants';

class UploadShipmentPhoto extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgURL: props.postAShipment.thumbnailImage || null
    }
    window.scrollTo(0,0);
  }
  componentWillReceiveProps(newProps){
    this.setState({
      imgURL: newProps.postAShipment.thumbnailImage
    })
  }
  componentDidMount(){
    const shipmentId = this.props.location.query.shipmentId;
    const self = this;
    const {props} = this;
    const {shipmentActions} = this.props;
    this.setState({
      shipmentId
    })
    if(shipmentId)
    {
      this.setState({isLoading: true});
      shipmentActions.clearShipmentDetails();
      shipmentActions.getShipmentDetails(shipmentId).then((data) => {
        self.setState({isLoading: false, error: ''});
        self.storeShipmentDetails(data)
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error})
      });
    }
  }
  storeShipmentDetails = (shipment) =>{
    this.props.postAShipmentActions.clearPostAShipmentDetails();

      let shipmentDetails = {
        thumbnailImage : shipment.thumbnailImage,
        title : shipment.title,
        shipmentId : shipment.shipmentId,
        shipmentCost : shipment.shipmentCost,
        itemValue : shipment.itemValue,
        description : shipment.description,
        imageIds: shipment.imageUrlList,
        pickupLat : shipment.pickupLat,
        pickupLong : shipment.pickupLong,
        pickupLocation : shipment.pickupLocation,
        pickupCountry : shipment.pickupCountry,
        pickupCity : shipment.pickupCity,
        pickupLandmark : shipment.pickupLandmark,
        deliveryLat : shipment.deliveryLat ,
        deliveryLong : shipment.deliveryLong ,
        deliveryLocation : shipment.deliveryLocation ,
        deliveryCountry : shipment.deliveryCountry ,
        deliveryCity : shipment.deliveryCity ,
        deliveryLandmark : shipment.deliveryLandmark,
        notes : shipment.notes,
        isIWillMeetCarrierAtDelivery : ((shipment.isIWillMeetCarrierAtDelivery != null) ? shipment.isIWillMeetCarrierAtDelivery :true ),
        isIWillMeetCarrierAtPickup : ((shipment.isIWillMeetCarrierAtPickup != null) ? shipment.isIWillMeetCarrierAtPickup :true ),
        deliveryDate :  moment().startOf('day').unix() *1000 + ((8*24*60*60*1000) - 60000),
        itemSize : shipment.itemSize,
        itemCategory : shipment.itemCategoryId,
        deliveryUser : shipment.deliveryUser || {},
        pickupUser : shipment.pickupUser || {}
      }
      this.props.postAShipmentActions.storeAShipmentDetail(shipmentDetails);
  }
  onImgUpload = (URL) =>{
    let imageIds = [];
    imageIds.push(URL)
    let data = {
      thumbnailImage : URL,
      imageIds
    }
    this.setState({
      imgURL : URL
    })
    this.props.postAShipmentActions.storeAShipmentDetail(data);
    if(this.state.shipmentId)
      browserHistory.push('/post-a-shipment/package-details?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/post-a-shipment/package-details');
  }
  submit = () =>{
    if(this.state.shipmentId)
      browserHistory.push('/post-a-shipment/package-details?shipmentId='+ this.state.shipmentId);
    else
      browserHistory.push('/post-a-shipment/package-details');
  }
  render() {
    const imgURL = this.state.imgURL;
    return (
      <div className ="upload-shipment-photo-wrap">
        {this.state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        <div className = "upload-shipment-photo">
          {
            !imgURL && <UploadPhotoComponent getImageUrlCallback = {this.onImgUpload}/>
          }
          {
            imgURL &&
            <div className = "selected-image-wrap">
              <div className = "heading">
                      Package Image
              </div>
              <div className = "selected-img" style={{"backgroundImage": 'url("' + imgURL + '")'}}></div>
              <div className = "submit-section">
              <div className = "submit-options">
                  <button className = "btn orange" onClick = {this.submit} >Next</button>
              </div>
            </div>
          </div>
          }
        </div>
        <LoggedinFooter/>
      </div>
    )
  }
}


UploadShipmentPhoto = connect((state) => {
  return {
    postAShipment : state.app.postAShipment
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    postAShipmentActions :bindActionCreators(postAShipmentActions, dispatch),
    shipmentActions: bindActionCreators(shipmentActions, dispatch)
  }
})(UploadShipmentPhoto);

export default UploadShipmentPhoto;



// WEBPACK FOOTER //
// app/post_a_shipment/upload_shipment_photo/upload_shipment_photo.jsx